import { render } from "./AtsiriEatPage.vue?vue&type=template&id=7146ded3&ts=true"
import script from "./AtsiriEatPage.vue?vue&type=script&lang=ts"
export * from "./AtsiriEatPage.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Lenz\\atsiriBookingApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__